import React from 'react';

import SliderItemModel from '../../Api/Models/SliderItem';

type Props = Readonly<{
    slide: SliderItemModel;
}>;

export default function SliderItem({ slide }: Props) {
    const isUsingMobileImage = window.innerWidth <= 640 && slide.mobile_image_url;
    let imageUrl = slide.image_url;
    let dimensions = slide.image_dimensions;

    if (isUsingMobileImage) {
        imageUrl = slide.mobile_image_url;
        dimensions = slide.mobile_image_dimensions;
    }

    const image = (
        <img
            className="slider-image"
            src={imageUrl}
            alt={slide.alt_value}
            width={dimensions.width}
            height={dimensions.height}
        />
    );

    return (
        <div className="slider-item">{slide.redirection_url ? <a href={slide.redirection_url}>{image}</a> : image}</div>
    );
}
